import { t } from '@avalara/bat-apps-shared/i18n';

export const getBillingTerms = (planSpecificBillingTerms: Array<string>, offerFlow: string) => {
  const firstSentence =
    offerFlow === 'exemptions'
      ? t('client.general.your-payment-method-will-be-used-for-automatic-payment-of-al')
      : t('client.billing-terms.first-sentence-default');

  return [firstSentence, t('client.billing-terms.second-sentence'), ...planSpecificBillingTerms];
};
